import * as Shared from "./shared";
//Pour communiquer avec le service worker
export const onMessage = (event) => {
    if (event.data?.type === "PING") {
        Shared.answerMessage(event, undefined);
    }
};
export async function sendMessageToSW(message) {
    if ("serviceWorker" in navigator) {
        const registration = await navigator.serviceWorker.ready;
        return new Promise((resolve, reject) => {
            const messageChannel = new MessageChannel();
            // Set up listener for the response
            messageChannel.port1.onmessage = (event) => {
                resolve(event.data);
                messageChannel.port1.close();
            };
            messageChannel.port1.onmessageerror = () => {
                reject("Message channel error");
                messageChannel.port1.close();
            };
            // Send the message to the service worker via port2
            if (registration.active) {
                registration.active.postMessage(message, [messageChannel.port2]);
            }
            else {
                reject("No active service worker found.");
            }
        });
    }
}
